import { Actions, MeteringPointVirtualGroupActionTypes } from '@appStore/metering-points/actions';
import { MeteringType } from '@enums';
export interface State {
  hot: number[];
  hotActivated: boolean;
  cold: number[];
  coldActivated: boolean;
}

export const initialState: State = {
  hot: [],
  cold: [],
  hotActivated: false,
  coldActivated: false
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case MeteringPointVirtualGroupActionTypes.SetSelection:
      if (action.payload.meteringType === MeteringType.Hot) {
        return {
          ...state,
          hot: [...action.payload.meteringPointIds],
          hotActivated: action.payload.meteringPointIds.length > 0 ? state.hotActivated : false
        };
      }
      if (action.payload.meteringType === MeteringType.Cold) {
        return {
          ...state,
          cold: [...action.payload.meteringPointIds],
          coldActivated: action.payload.meteringPointIds.length > 0 ? state.coldActivated : false
        };
      }
      return state;
    case MeteringPointVirtualGroupActionTypes.ActivateVirtualGroup:
      if (action.payload === MeteringType.Hot) {
        return { ...state, hotActivated: true };
      }
      if (action.payload === MeteringType.Cold) {
        return { ...state, coldActivated: true };
      }
      return state;
    case MeteringPointVirtualGroupActionTypes.DeactivateVirtualGroup:
      if (action.payload === MeteringType.Hot) {
        return { ...state, hotActivated: false };
      }
      if (action.payload === MeteringType.Cold) {
        return { ...state, coldActivated: false };
      }
      return state;
  }
  return state;
}

export const getVirtualGroup = (state: State) => state;
